import { Col } from 'antd';
import querystring from 'query-string';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { AttrSlugType } from '~src/interfaces/attributes.types';
import { CompanyI } from '~src/interfaces/company.interface';
import { CycleI } from '~src/interfaces/cycle.interface';
import { ScheduleI } from '~src/interfaces/schedule.interface';
import { getAttributeBySlug } from '~src/modules/attributes/reducers/attributes.reducer';
import CopyableInput from '~src/outer_modules/shared/copyableInput';
import QRCodeGenerator from '~src/outer_modules/shared/qrCodeGenerator';
import { StoreI } from '~src/rootReducer';
import { routes } from '~src/routingConfig';
import { defaultPulseCheckApi } from '~src/services/ApiController';
import SvgIcon from '~src/shared/SvgIcon';
import * as SC from './surveyInvite.sc';

interface InviteProps {
  schedule: ScheduleI;
}

export const SurveyInvite: React.FC<InviteProps> = (props) => {
  const [showQRModal, setShowQRModal] = useState(false);
  const [currentSurveyCycle, setCurrentSurveyCycle] = useState<CycleI>();

  const company = useSelector<StoreI, CompanyI>((state) => state.user.session.company!);
  const [t] = useTranslation();
  
  const isSelfSignupEnabled = useSelector<StoreI>((state) => {
    const selfSignupId = getAttributeBySlug(state, AttrSlugType.SelfSignUp)?.uuid;
    return state.user?.session?.company?.setting_attributes[selfSignupId] || false;
  });

  useEffect(() => {
    if (props.schedule.id) {
      void defaultPulseCheckApi.getScheduleCycles(props.schedule.id).then((response) => {
        if (props.schedule.id) {
          setCurrentSurveyCycle(response.data[0]);
        }
      });
    } else {
      setCurrentSurveyCycle(undefined);
    }
  }, [props.schedule.id]);

  if (!isSelfSignupEnabled || !currentSurveyCycle) {
    return null;
  }

  const surveySelfSignupLink =`${window.location.origin}${routes.selfSignup(company.uuid)}?${querystring.stringify({
    cycle: currentSurveyCycle.id,
  })}`;

  return (
    <SC.SurveyInviteWrapper>
      <SC.Header data-translation="x.surveys.schedule.invite.description">
        {t('x.surveys.schedule.invite.description')}
      </SC.Header>
      <SC.Details>
        <Col lg={16} sm={10}>
          <CopyableInput value={surveySelfSignupLink} />
        </Col>
        <Col lg={8} sm={10} style={{ marginLeft: '30px' }}>
          <SC.QRCodeLabelContainer
            data-translation={'x.surveys.schedule.invite.qr.code.label'}
            onClick={() => setShowQRModal(!showQRModal)}
          >
            <SC.QRCodeIcon>
              <SvgIcon width={25} name="qrCode" />
            </SC.QRCodeIcon>
            <SC.QRCodeLabel>{t('x.surveys.schedule.invite.qr.code.label')}</SC.QRCodeLabel>
          </SC.QRCodeLabelContainer>
        </Col>
      </SC.Details>
      <SC.DialogStyled show={showQRModal} onHide={() => setShowQRModal(!showQRModal)} width={800}>
        <SC.DialogHeader data-translation="x.surveys.schedule.invite.qr.code.header">
          {t('x.surveys.schedule.invite.qr.code.header')}
        </SC.DialogHeader>
        <QRCodeGenerator url={surveySelfSignupLink} />
      </SC.DialogStyled>
    </SC.SurveyInviteWrapper>
  );
};
